
export default {
    SET_STATION: function (state, stations) {
        state.ws = stations;
    },

    SET_VIEW_WS_LAYER: function (state, status) {
        state.viewWsLayer = status;
    },

    SET_WS_LOADING: function (state, status) {
        state.wsLoading = status;
    },

    SET_WS_CREATING: function (state, status) {
        state.wsCreating = status;
    },
    
    // Toggle deleting state for a specific station id
    SET_WS_DELETING: function (state, { id, status }) {
        state.wsDeleting = { ...state.wsDeleting, [id]: status };
    },

    // Remove a station from the list by id
    REMOVE_STATION: function (state, id) {
        state.ws = state.ws.filter(s => s._id !== id);
        if (state.wsDeleting && Object.prototype.hasOwnProperty.call(state.wsDeleting, id)) {
            delete state.wsDeleting[id];
        }
    },
    
    SET_VIEW_WEATHER_STATION_MANAGER: function (state, status) {
        state.viewWeatherStationManager = status;
    }
}
